var __decorate=this&&this.__decorate||function(o,t,e,r){var n,i=arguments.length,a=i<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,e):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(o,t,e,r);else for(var c=o.length-1;c>=0;c--)(n=o[c])&&(a=(i<3?n(a):i>3?n(t,e,a):n(t,e))||a);return i>3&&a&&Object.defineProperty(t,e,a),a};import{css as o,html as t}from"lit";import{OrElement as e}from"@openremote/or-element";import{customElement as r,state as n}from"lit/decorators.js";import{OrMapBaseControl as i}from"./base";import{i18next as a}from"@openremote/or-translate";import"@openremote/or-vaadin-components/or-vaadin-button";import"@openremote/or-icon";let OrMapNavigation=class extends e{constructor(){super(...arguments),this._bearing=0,this._onRotate=()=>{var o,t;this._bearing=-(null!=(t=null==(o=this._map)?void 0:o.getBearing())?t:0)}}static get styles(){return o`
      :host {
        display: flex;
        flex-direction: column;
        background: white;
        overflow: hidden;
        border-radius: var(--lumo-border-radius-m, 4px);
      }

      or-vaadin-button {
        --lumo-border-radius-m: 0;
      }

      or-icon {
        --or-icon-width: 18px;
        --or-icon-height: 18px;
        color: black;
        transition: transform 0.1s ease;
      }
    `}setMap(o){this._map=o,o.on("rotate",this._onRotate)}disconnectedCallback(){var o;super.disconnectedCallback(),null==(o=this._map)||o.off("rotate",this._onRotate)}render(){return t`
      <or-vaadin-button theme="icon" title="${a.t("mapPage.zoomIn")}" @click="${()=>{var o;return null==(o=this._map)?void 0:o.zoomIn()}}">
        <or-icon icon="mdi:plus"></or-icon>
      </or-vaadin-button>
      <or-vaadin-button theme="icon" title="${a.t("mapPage.zoomOut")}" @click="${()=>{var o;return null==(o=this._map)?void 0:o.zoomOut()}}">
        <or-icon icon="mdi:minus"></or-icon>
      </or-vaadin-button>
      <or-vaadin-button
        theme="icon"
        title="${a.t("mapPage.resetBearing")}"
        @click="${()=>{var o;return null==(o=this._map)?void 0:o.resetNorthPitch({duration:200})}}"
      >
        <or-icon icon="or:compass" style="transform: rotate(${this._bearing}deg)"></or-icon>
      </or-vaadin-button>
    `}};__decorate([n()],OrMapNavigation.prototype,"_bearing",void 0),OrMapNavigation=__decorate([r("or-map-navigation")],OrMapNavigation);export class OrMapNavigationControl extends i{onAdd(o){return this._createContainer(),this._component=document.createElement("or-map-navigation"),this._component.setMap(o),this._container.appendChild(this._component),this._container}onRemove(){super.onRemove(),this._component=void 0}}export{OrMapNavigation};